import styled from 'styled-components';

import { Button } from '@mui/material';
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ButtonAdd = styled(Button)`
    border-width: 1px;
    width: ${(props) => props.width || '148px'};
    height: ${(props) => props.height || '32px'};
    border-color: #3a6647;
    color: #3a6647;
    font-weight: 600;
    text-transform: none !important;
    &:hover {
        border-width: 1px;
        border-color: #3a6647;
        color: #3a6647;
        font-weight: 600;
    }
`;
